export default {
    data() {
        return {
            // 搜索条件
            form: {
                // 学员登录名
                code: '',
                // 学员姓名
                name: '',
                // 身份证号
                idcard: '',
                // 单位
                company: '',
                // 课程类型
                type: '',
                // 课程名称
                productName: '',
                // 学时
                period: '',
                // 学习进度
                progress: '',
                // 大于或等于开始学习时间
                startTimeAtEgt: '',
                // 小于或等于开始学习时间
                startTimeAtEglt: '',
                // 大于或等于完成时间
                finishTimeAtEgt: '',
                // 小于或等于完成时间
                finishTimeAtEglt: '',
                // 申报年度
                declare: '',
                // 申报结果
                result: '',
                // 学习状态
                learningState: '',
                // 开课人
                managers: ''
            },
            // 学习状态
            studyState: [
                {
                    value: 1,
                    label: '已完成'
                },
                {
                    value: 2,
                    label: '学习中'
                },
                {
                    value: 3,
                    label: '未开始'
                }
            ],
            // 所属年度
            years: [
                {
                    value: 1,
                    label: '2020'
                }
            ],
            // 课程包名称
            categoryNames: [
                {
                    value: 1,
                    label: '计算机'
                },
                {
                    value: 2,
                    label: '城建'
                }
            ],
            // 课程类型
            classTypes: [
                {
                    value: 1,
                    label: '公需课'
                },
                {
                    value: 2,
                    label: '专业课'
                },
                {
                    value: 3,
                    label: '选修课'
                },
            ],
            // 主网学习情况数据
            tableData: [
                {
                    id: 1,
                    code: '156461348',
                    name: '张三',
                    idcard: '6546146187',
                    company: '单位',
                    type: '专业课',
                    productName: '撒大苏打撒大苏打',
                    period: 23,
                    year: '2020',
                    progress: 0.54,
                    payType: 1,
                    startStudyTime: '2020-01-12 21:56:51',
                    finishStudyTime: '2020-01-12 21:56:51',
                    result: '已申报学时',
                    managers: '开课人',
                },
                {
                    id: 2,
                    code: '156461348',
                    name: '张三',
                    idcard: '6546146187',
                    company: '单位',
                    type: '专业课',
                    productName: '撒大苏打撒大苏打',
                    period: 23,
                    year: '2020',
                    progress: 0.54,
                    payType: 1,
                    startStudyTime: '2020-01-12 21:56:51',
                    finishStudyTime: '2020-01-12 21:56:51',
                    result: '已申报学时',
                    managers: '开课人',
                },
                {
                    id: 3,
                    code: '156461348',
                    name: '张三',
                    idcard: '6546146187',
                    company: '单位',
                    type: '专业课',
                    productName: '撒大苏打撒大苏打',
                    period: 23,
                    year: '2020',
                    progress: 0.54,
                    payType: 1,
                    startStudyTime: '2020-01-12 21:56:51',
                    finishStudyTime: '2020-01-12 21:56:51',
                    result: '已申报学时',
                    managers: '开课人',
                },
                {
                    id: 4,
                    code: '156461348',
                    name: '张三',
                    idcard: '6546146187',
                    company: '单位',
                    type: '专业课',
                    productName: '撒大苏打撒大苏打',
                    period: 23,
                    year: '2020',
                    progress: 0.54,
                    payType: 1,
                    startStudyTime: '2020-01-12 21:56:51',
                    finishStudyTime: '2020-01-12 21:56:51',
                    result: '已申报学时',
                    managers: '开课人',
                },
                {
                    id: 5,
                    code: '156461348',
                    name: '张三',
                    idcard: '6546146187',
                    company: '单位',
                    type: '专业课',
                    productName: '撒大苏打撒大苏打',
                    period: 23,
                    year: '2020',
                    progress: 0.54,
                    payType: 1,
                    startStudyTime: '2020-01-12 21:56:51',
                    finishStudyTime: '2020-01-12 21:56:51',
                    result: '已申报学时',
                    managers: '开课人',
                },
            ],
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
        }
    },
    methods: {
        search() {
            console.log(this.form);
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
        }
    },
    filters: {
        studyStateFilter(value) {
            if (value == 0) {
                return '未开始'
            } else if (value == 1) {
                return '已完成'
            } else {
                return '学习中';
            }
        },

        studyProgress(value) {
            return value * 100 + '%';
        },

        payType(value) {
            switch(Number.parseInt(value)) {
                case 1:
                    return '支付宝';
                    break;
                case 2:
                    return '微信';
                    break;
                case 3:
                    return '批量开课';
                    break;
                case 5:
                    return '余额支付';
                    break;
                case 6:
                    return '郑州银行';
                    break;
            }
        }
    }
}